<template>
  <div class="member-privilege" :class="{ isiOSX: isiOSX }">
    <van-nav-bar
      title="我的会员"
      right-text="充值记录"
      left-arrow
      @click-left="goBack"
      @click-right="rechargeRecord"
    />
    <van-row class="member-msg">
      <van-col span="24" :style="msgStyle" :class="{ msg_short: !tipWords }">
        <img class="avatar" :src="head_pic" @error="nofind()" />
        <p class="name" :style="memberMsgColor">{{ nickname }}</p>
        <span class="level" v-if="level_1" :style="memberMsgColor"
          >普通会员</span
        >
        <span class="level" v-if="level_2" :style="memberMsgColor"
          >积分VIP会员</span
        >
        <span class="level" v-if="level_3" :style="memberMsgColor"
          >VIP会员<span v-if="showTime">{{ downcount.dd }}天到期</span></span
        >
        <span class="level" v-if="level_4" :style="memberMsgColor"
          >永久VIP</span
        >
        <span class="level" v-if="level_5" :style="memberMsgColor"
          >积分城市代理人</span
        >
        <span class="level" v-if="level_6" :style="memberMsgColor"
          >城市代理人<span v-if="showTime">{{ downcount.dd }}天到期</span></span
        >
        <span class="level" v-if="level_7" :style="memberMsgColor"
          >永久城市代理人</span
        >

        <p class="speed" v-if="tipWords"><span :style="speed"></span></p>
        <p class="tip" v-if="tipWords" :style="memberMsgColor">
          {{ tipWords }}
        </p>
        <img
          class="label"
          src="../../assets/member/label_member@2x.png"
          v-if="level_1"
        />
        <img
          class="label"
          :class="{ label_short: !tipWords }"
          src="../../assets/member/label_vip@2x.png"
          v-if="level_2 || level_3 || level_4"
        />
        <img
          class="label"
          :class="{ label_short: !tipWords }"
          src="../../assets/member/label_city@2x.png"
          v-if="level_5 || level_6 || level_7"
        />
      </van-col>
    </van-row>
    <van-row class="welfare">
      <van-col span="6">
        <img src="../../assets/member/icon_pt1@2x.png" v-if="level_1" />
        <img
          src="../../assets/member/icon_vip1@2x.png"
          v-if="level_2 || level_3 || level_4"
        />
        <img
          src="../../assets/member/icon_city1@2x.png"
          v-if="level_5 || level_6 || level_7"
        />
        <p class="tit" v-if="level_1">万三速率</p>
        <p class="tit" v-if="level_2 || level_3 || level_4">万四速率</p>
        <p class="tit" v-if="level_5 || level_6 || level_7">万五速率</p>
        <p>每日赠红包</p>
      </van-col>
      <van-col span="6">
        <img src="../../assets/member/icon_pt4@2x.png" v-if="level_1" />
        <img
          src="../../assets/member/icon_vip2@2x.png"
          v-if="level_2 || level_3 || level_4"
        />
        <img
          src="../../assets/member/icon_city2@2x.png"
          v-if="level_5 || level_6 || level_7"
        />
        <p class="tit">100%积分</p>
        <p>消费赠积分</p>
      </van-col>
      <van-col span="6">
        <img src="../../assets/member/icon-pt3@2x.png" v-if="level_1" />
        <img
          src="../../assets/member/icon_vip3@2x.png"
          v-if="level_2 || level_3 || level_4"
        />
        <img
          src="../../assets/member/icon_city3@2x.png"
          v-if="level_5 || level_6 || level_7"
        />
        <p class="tit">满百提现</p>
        <p>到账88元</p>
      </van-col>
      <van-col span="6">
        <img src="../../assets/member/icon-pt2@2x.png" v-if="level_1" />
        <img
          src="../../assets/member/icon_vip4@2x.png"
          v-if="level_2 || level_3 || level_4"
        />
        <img
          src="../../assets/member/icon_city4@2x.png"
          v-if="level_5 || level_6 || level_7"
        />
        <p class="tit">专属徽章</p>
        <p v-if="level_1">普通会员</p>
        <p v-if="level_2 || level_3 || level_4">VIP会员</p>
        <p v-if="level_5 || level_6 || level_7">城市代理人</p>
      </van-col>
    </van-row>
    <van-row class="identity" v-if="!level_7">
      <van-col
        span="12"
        class="left"
        :class="{ active: isFirst }"
        @click="updateType(1)"
        v-if="!level_4 && !level_5 && !level_6"
      >
        VIP会员
      </van-col>
      <van-col
        span="12"
        class="right"
        :class="{ active: !isFirst }"
        @click="updateType(2)"
        v-if="!level_4 && !level_5 && !level_6"
      >
        城市代理人
      </van-col>
      <van-col
        span="24"
        class="center"
        :class="{ active: !isFirst }"
        v-if="level_4 || level_5 || level_6"
      >
        开通永久城市代理人
      </van-col>
      <van-col
        span="24"
        class="rate"
        v-if="
          level_1 || (level_2 && !isFirst) || (level_3 && !isFirst) || level_4
        "
        :style="speedBoxImg"
      >
        <img
          :style="speedImg"
          src="../../assets/member/speed_vip@2x.png"
          v-if="level_1 && isFirst"
        />
        <img
          :style="speedImg"
          src="../../assets/member/apeed_city@2x.png"
          v-if="level_1 && !isFirst"
        />
        <img
          :style="speedImg"
          src="../../assets/member/speed_city_vip@2x.png"
          v-if="(level_2 && !isFirst) || (level_3 && !isFirst) || level_4"
        />
      </van-col>
    </van-row>
    <van-row class="model" v-if="!isTestPeople">
      <van-col span="24" class="title" v-if="level_1">{{
        privilegeTip
      }}</van-col>
      <van-col span="8" class="model_1" v-if="level == 1">
        <div :class="{ active: sty == 1 }" @click="changeType(1, 35)">
          <p class="tit">季度VIP</p>
          <p class="money">￥<span>99</span></p>
          <p class="tip">立赠99积分</p>
        </div>
      </van-col>
      <van-col span="8" class="model_1" v-if="level == 1">
        <div :class="{ active: sty == 2 }" @click="changeType(2, 36)">
          <p class="tit">半年VIP</p>
          <p class="money">￥<span>159</span></p>
          <p class="tip">立赠159积分</p>
        </div>
      </van-col>
      <van-col span="8" class="model_1" v-if="level == 1">
        <div :class="{ active: sty == 3 }" @click="changeType(3, 40)">
          <span class="label">推荐</span>
          <p class="tit">永久VIP</p>
          <p class="money">￥<span>1000</span></p>
          <p class="tip">立赠1000积分</p>
        </div>
      </van-col>
      <van-col span="24" class="model_1 model_2" v-if="level == 3">
        <div class="active">
          <p class="tit">永久VIP会员</p>
          <span class="money">￥<span>1000</span></span>
          <p class="tip">立赠1000积分</p>
        </div>
      </van-col>
      <van-col span="24" class="model_1 model_2" v-if="level == 2">
        <div class="active">
          <p class="tit">永久城市代理人</p>
          <span class="money" v-if="level_4">￥<span>1000</span></span>
          <span class="money" v-else>￥<span>2000</span></span>
          <p class="tip" v-if="level_4">立赠1000积分</p>
          <p class="tip" v-else>立赠2000积分</p>
        </div>
      </van-col>
    </van-row>
    <van-row class="btn" v-if="btnMsg && !isTestPeople">
      <van-col span="24" class="button" @click="upGrade1">{{ btnMsg }}</van-col>
    </van-row>
  </div>
</template>

<script>
import defaultImg from "@/assets/common/avatar.png";
export default {
  data() {
    return {
      isiOSX: false,
      leftColor: "",
      rightColor: "",
      msgStyle: {},
      level: 0, //level控制左边的套餐   0.不显示套餐   1.普通会员升级vip套餐(3种)   2.升级城代(1种)  3.积分vip升级永久vip
      level_1: false, //level_1 普通会员
      level_2: false, //level_2 积分vip
      level_3: false, //level_3 临时vip
      level_4: false, //level_4 永久vip
      level_5: false, //level_5 积分城代
      level_6: false, //level_6 临时城代
      level_7: false, //level_7 永久城代
      sty: 1,
      head_pic: "",
      nickname: "",
      upGradeID: 0,
      showTime: false,
      downcount: {
        mm: "",
        dd: "",
      },
      flag: 0,
      speed: {},
      isFirst: true,
      levelId: "",
      tipWords: "",
      btnMsg: "",
      memberMsgColor: {},
      privilegeTip: "开通后立刻享受VIP权益",
      speedImg: {
        height: (document.body.clientWidth - 24) * 0.8 * 0.46 + "px",
      },
      speedBoxImg: {
        height: (document.body.clientWidth - 24) * 0.8 * 0.46 + 22 + "px",
      },
      isTestPeople: true,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    // this.$api.setToken(this.$route.query.token);
    this.getInfo();
  },
  methods: {
    updateType(data) {
      this.level = data;
      if (data == 1 && (this.levelId == 10 || this.levelId == 35)) {
        this.isFirst = true;
        this.sty = 1;
        this.btnMsg = "99元季度VIP 立即开通";
        this.upGradeID = 35;
        this.privilegeTip = "开通后立刻享受VIP权益";
      } else if (data == 1 && this.levelId == 25) {
        this.isFirst = true;
        this.level = 3;
        this.btnMsg = "1000元永久权益 立即开通";
        this.upGradeID = 40;
      } else if (data == 2) {
        this.isFirst = false;
        this.btnMsg = "2000元永久权益 立即开通";
        this.upGradeID = 50;
        this.privilegeTip = "开通后立刻享受城市代理人权益";
      }
    },
    changeType(data, Id) {
      this.sty = data;
      this.upGradeID = Id;
      if (data == 1) {
        this.btnMsg = "99元季度VIP 立即开通";
      } else if (data == 2) {
        this.btnMsg = "159元半年VIP 立即开通";
      } else if (data == 3) {
        this.btnMsg = "1000元永久权益 立即开通";
      }
    },
    getInfo() {
      var mid = this.$route.query.mid;
      this.$api
        .post("/member/member/member/levels/detail", { member_id: mid })
        .then((res) => {
          //isTestPeople
          if (res.id != 1873418 && res.id != 1809228) {
            this.isTestPeople = false;
          }
          this.head_pic = res.infos.head_pic || "aaa.png";
          this.nickname = res.nickname;
          let level_id = res.member_levels.level;
          this.levelId = level_id;
          //level控制左边的套餐   0.不显示套餐   1.普通会员升级vip套餐(3种)   2.升级城代(1种)  3.积分vip升级永久vip
          //level_id   10 普通会员 25 VIP(积分) 35 临时vip 40 vip(终身) 50 城市代理人  20 城市代理人(积分) 30 临时城市代理人
          if (level_id == 10) {
            var diffCredits = (100000 - res.nowCredits).toFixed(4);
            var speedWidth = (res.nowCredits / 100000) * 100;
            this.level_1 = true;
            this.level = 1;
            this.upGradeID = 35;
            this.memberMsgColor = { color: "#354D6B" };
            this.tipWords = "差" + diffCredits + "积分成为VIP会员";
            this.btnMsg = "99元季度VIP 立即开通";
            this.speed = { width: speedWidth + "%", background: "#E3F4FF" };
          } else if (level_id == 25) {
            this.level_2 = true;
            this.level = 3;
            this.upGradeID = 40;
            this.memberMsgColor = { color: "#9F5D00" };
            this.tipWords = "当积分低于10万将降级为普通会员";
            this.btnMsg = "1000元永久权益 立即开通";
            this.speed = { width: "100%", background: "#FFF1E8" };
          } else if (level_id == 35) {
            this.level_3 = true;
            this.level = 1;
            this.upGradeID = 35;
            this.memberMsgColor = { color: "#9F5D00" };
            this.btnMsg = "99元季度VIP 立即开通";

            this.downcount.dd = this.timeDiff(res.vip_date);
            this.showTime = true;
          } else if (level_id == 40) {
            this.level_4 = true;
            this.level = 2;
            this.upGradeID = 50;
            this.isFirst = false;
            this.memberMsgColor = { color: "#9F5D00" };
            this.btnMsg = "1000元永久权益 立即开通";
          } else if (level_id == 20) {
            this.level_5 = true;
            this.level = 2;
            this.upGradeID = 50;
            this.isFirst = false;
            this.memberMsgColor = { color: "#E8C9A8" };
            this.tipWords = "当积分低于10万将降级为普通会员";
            this.btnMsg = "2000元永久权益 立即开通";
            this.speed = { width: "100%", background: "#EECCAE" };
          } else if (level_id == 30) {
            this.level_6 = true;
            this.level = 2;
            this.upGradeID = 50;
            this.isFirst = false;
            this.memberMsgColor = { color: "#E8C9A8" };
            this.btnMsg = "2000元永久权益 立即开通";

            this.downcount.dd = this.timeDiff(res.vip_date);
            this.showTime = true;
          } else {
            //城市代理人
            this.level_7 = true;
            this.memberMsgColor = { color: "#E8C9A8" };
          }

          this.setColor();
        });
    },
    toInvest() {
      this.params("", "", "toInvest");
    },
    upGrade1() {
      this.flag++;
      if (this.flag == 1) {
        this.upGrade();
        setTimeout(() => {
          this.flag = 0;
        }, 2000);
      }
    },
    upGrade() {
      this.params(this.upGradeID, this.upGradeID, "upGrade");
    },
    setColor() {
      if (this.level_1) {
        this.leftColor = "#B0C3E4";
        this.rightColor = "#789BC9";
      } else if (this.level_2 || this.level_3 || this.level_4) {
        this.leftColor = "#F2D6B3";
        this.rightColor = "#E9B075";
      } else if (this.level_5 || this.level_6 || this.level_7) {
        this.leftColor = "#5E5754";
        this.rightColor = "#37363D";
      }

      this.msgStyle = {
        background:
          "-webkit-linear-gradient(to right, " +
          this.leftColor +
          ", " +
          this.rightColor +
          ")",
        background:
          "-o-linear-gradient(to right, " +
          this.leftColor +
          ", " +
          this.rightColor +
          ")",
        background:
          "-moz-linear-gradient(to right, " +
          this.leftColor +
          ", " +
          this.rightColor +
          ")",
        background:
          "linear-gradient(to right, " +
          this.leftColor +
          ", " +
          this.rightColor +
          ")",
      };
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    goBack() {
      this.params("", "", "goBack");
    },
    rechargeRecord() {
      this.params("", "", "rechargeRecord");
    },
    timeDiff(end_time) {
      var endTime = this.date2timestamp(end_time);
      //	  		var today = new Date().getFullYear()+'-'+(new Date().getMonth() + 1)+'-'+new Date().getDate();
      //	  		var current = Math.floor(new Date(today).getTime() / 1000);
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = endTime - current;

      if (ts <= 0) {
        return 0;
      } else {
        var dd = parseInt(ts / 60 / 60 / 24, 10);
        var hh = parseInt(ts / 60 / 60, 10) - dd * 24;
        if (hh > 0) {
          dd = dd + 1;
        }
        return dd;
      }
    },
  },
};
</script>

<style lang="less">
.member-privilege {
  height: 100%;
  background: #ffffff;
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    border: none;
    box-shadow: none;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    .van-nav-bar__title {
      color: #333;
      font-size: 18px;
      font-weight: 700;
    }
    .van-nav-bar__text {
      color: #666 !important;
      font-size: 14px !important;
      font-weight: 400;
    }
    .van-icon {
      color: #333;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .member-msg {
    height: auto;
    // height: 129px;
    padding: 68px 12px 0;
    .van-col {
      padding-bottom: 19px;
      border-radius: 10px;
      position: relative;
      .name {
        color: #354d6b;
        font-size: 18px;
        height: 29px;
        line-height: 29px;
        padding-left: 80px;
        margin: 24px 0 0 0;
        width: 144px;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .level {
        color: #354d6b;
        font-size: 14px;
        height: 19px;
        line-height: 19px;
        text-align: center;
        margin-left: 80px;
      }
      .level2 {
        border: none;
        span {
          margin-left: 4px;
        }
      }
      .speed {
        width: 208px;
        height: 4px;
        border-radius: 2px;
        background: #5d7893;
        margin-top: 35px;
        margin-left: 16px;
        position: relative;
        span {
          // background: #E3F4FF;
          height: 4px;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .tip {
        color: #354d6b;
        font-size: 12px;
        padding-left: 16px;
        line-height: 19px;
        margin: 6px 0 0 0;
      }
      .avatar {
        width: 56px;
        height: 56px;
        border: solid 1px #fff;
        border-radius: 28px;
        position: absolute;
        top: 20px;
        left: 16px;
      }
      .label {
        width: 76px;
        position: absolute;
        top: 40px;
        right: 10px;
      }
      .label_short {
        top: 20px;
      }
      // @media screen and (max-width: 320px) {
      // 	.label {
      // 		width: 45px;
      // 		right: 29px;
      // 	}
      // }
    }
    .msg_short {
      padding-bottom: 25px;
    }
  }
  .welfare {
    text-align: center;
    img {
      width: 42px;
      height: 38px;
      display: inline-block;
      margin: 16px 0 4px;
    }
    p {
      color: #999999;
      font-size: 12px;
      line-height: 19px;
    }
    .tit {
      color: #333333;
      font-size: 14px;
      line-height: 23px;
      font-weight: 700;
    }
  }
  .identity {
    color: #999999;
    font-size: 14px;
    height: 29px;
    line-height: 29px;
    padding: 16px 12px 0;
    .left {
      padding-right: 20px;
      text-align: right;
      margin-bottom: 12px;
    }
    .right {
      padding-left: 20px;
      text-align: left;
      margin-bottom: 12px;
    }
    .center {
      text-align: center;
      margin-bottom: 12px;
    }
    .active {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
    }
    .rate {
      background: #ffffff;
      border: solid 1px #eeeeee;
      border-radius: 8px;
      padding: 8px 0 12px;
      text-align: center;
      margin-bottom: 12px;
      box-shadow: 0 4px 16px rgba(153, 153, 153, 0.08);
      img {
        width: 80%;
        height: auto;
        display: inline-block;
      }
    }
  }
  .model {
    padding: 0 6px;
    .title {
      text-align: center;
      color: #333333;
      font-size: 16px;
      font-weight: 700;
      height: 26px;
      line-height: 26px;
      margin-bottom: 12px;
    }
    .model_1 {
      padding: 0 6px;
      div {
        width: 100%;
        background: #ffffff;
        border: solid 1px #e9e7e6;
        border-radius: 8px;
        padding-bottom: 15px;
        text-align: center;
        position: relative;
        .tit {
          color: #333333;
          font-weight: 14px;
          height: 23px;
          line-height: 23px;
          margin-top: 18px;
        }
        .money {
          color: #d19018;
          font-size: 16px;
          span {
            font-size: 24px;
            font-weight: 700;
            height: 33px;
            line-height: 33px;
            margin-block: 5px;
          }
        }
        .tip {
          color: #999999;
          font-size: 13px;
          height: 21px;
          line-height: 21px;
        }
        .label {
          width: 34px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          color: #ffffff;
          font-size: 13px;
          display: inline-block;
          border-top-left-radius: 8px;
          border-bottom-right-radius: 8px;
          position: absolute;
          top: 0;
          left: 0;
          background: -webkit-linear-gradient(
            to right,
            #ff7961,
            #ff4444
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #ff7961,
            #ff4444
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #ff7961,
            #ff4444
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(
            to right,
            #ff7961,
            #ff4444
          ); /* 标准的语法（必须放在最后） */
        }
      }
      .active {
        background: #fff9f1;
        border: solid 1px #d8a170;
      }
    }
    .model_2 {
      div {
        width: auto;
        text-align: left;
        padding-left: 20px;
        padding-bottom: 18px;
        .tit {
          color: #9f5d00;
          font-size: 16px;
          font-weight: 700;
          height: 19px;
          line-height: 19px;
        }
        .tip {
          color: #9f5d00;
          font-size: 12px;
          height: 19px;
          line-height: 19px;
          margin-top: 6px;
        }
        .money {
          color: #9f5d00;
          font-size: 14px;
          position: absolute;
          right: 20px;
          top: 28px;
          span {
            color: #6a4219;
            font-size: 24px;
            font-weight: 900;
            height: 24px;
            line-height: 24px;
          }
        }
      }
    }
  }
  .btn {
    padding: 20px 12px 50px;
    .button {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #e8c9a8;
      font-size: 16px;
      font-weight: 900;
      border-radius: 25px;
      background: -webkit-linear-gradient(
        to right,
        #5e5754,
        #37363d
      ); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(
        to right,
        #5e5754,
        #37363d
      ); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(
        to right,
        #5e5754,
        #37363d
      ); /* Firefox 3.6 - 15 */
      background: linear-gradient(
        to right,
        #5e5754,
        #37363d
      ); /* 标准的语法（必须放在最后） */
    }
  }
}
.isiOSX {
  .van-nav-bar {
    padding-top: 44px;
  }
  .member-msg {
    padding-top: 88px;
  }
}
</style>
